<div id="documents-tab" [ngClass]="compactView ? 'documents-compact-view' : ''">
  <div *ngIf="showActions && readyToLoad" class="tw-flex">

    <div class="tw-flex-1">
      <div class="column-grid tw-justify-start tw-gap-2">
        <div class="tw-flex-1 tw-mr-1">
          <mat-form-field class="filter-input no-subscript lendio-density-2" placeholder="Search">
            <input matInput
              type="text"
              data-cy="filter-docs-input"
              [(ngModel)]="dataSource.filter"
              [placeholder]="searching ? '' : 'Search'"
              (focus)="searching = true"
              (blur)="searching = false"
            />
            <mat-icon matSuffix class="!tw-py-0 {{ !!dataSource.filter ? 'tw-cursor-pointer' : '' }}" (click)="dataSource.filter = ''">{{ !!dataSource.filter ? 'close' : 'search' }}</mat-icon>
          </mat-form-field>
        </div>
        <div class="tw-flex-1 tw-mr-1">
          <mat-form-field @animateIn
            *ngIf="selection.selected.length > 1"
            class="document-bulk-actions no-subscript lendio-density-2"
            (click)="$event.stopPropagation()">
            <mat-label>Actions</mat-label>
            <mat-select>
              <mat-option (click)="viewSelected()">View ({{ selection.selected.length }})</mat-option>
              <mat-option (click)="confirmDelete(selection.selected)">Delete ({{ selection.selected.length }})</mat-option>
              <mat-option (click)="downloadSelected()">Download ({{ selection.selected.length }})</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="column-grid tw-gap-2">
      <div>
        <button *ngIf="canProcessDocs && selection.selected.length > 0 && !ocrolusDisable"
                @animateIn
                [disabled]="sending || ocrolusDisable"
                [matTooltip]="ocrolusDisableReason"
                mat-flat-button
                (click)="processDocuments()">
          <mat-spinner *ngIf="sending; else process"
                       class="upload-spinner"
                       [diameter]="25"
                       [color]="warn">
          </mat-spinner>
          <ng-template #process> Process ({{ selection.selected.length }}) </ng-template>
        </button>
      </div>
      <div class="tw-flex-1">
        <button data-cy="import-app-btn"
                mat-stroked-button
                color="primary"
                (click)="previewApplication()">
          Import App
        </button>
      </div>
      <button mat-stroked-button color="primary" data-cy="pull-credit-btn" [matMenuTriggerFor]="menu">Pull Credit</button>
      <mat-menu #menu="matMenu">
        <div matTooltip="{{ creditPullDisableMessage }}" matTooltipPosition="left" [matTooltipDisabled]="!isPullingCredit && canSoftPullCredit">
          <button
            mat-menu-item
            [disabled]="isPullingCredit || !canSoftPullCredit"
            data-cy="pull-personal-credit-btn"
            (click)="repullCredit()">
            <mat-spinner *ngIf="isPullingCredit; else repull"
                         class="upload-spinner"
                         [diameter]="25"
                         [color]="warn">
            </mat-spinner>
            <ng-template #repull>Personal</ng-template>
          </button>
        </div>
        <div matTooltip="{{ (canViewExperianCommercialButton$ | async) ? creditPullDisableMessage : 'Coming soon!' }}" matTooltipPosition="left">
          <button
            mat-menu-item
            [disabled]="creditPullDisableMessage || !(canViewExperianCommercialButton$ | async)"
            class="header-btn"
            data-cy="pull-commercial-credit-btn"
            (click)="runExperianCommercial()">
            Commercial
          </button>
        </div>
      </mat-menu>
      <div class="tw-flex-1">
        <button
          color="primary"
          [disabled]="isUploading"
          data-cy="upload-doc-btn"
          mat-raised-button
          class="tw-flex tw-items-center"
          (click)="fileInput.click()">
          <mat-spinner *ngIf="isUploading; else upload"
                       class="upload-spinner"
                       [diameter]="25">
          </mat-spinner>
          <ng-template #upload> Upload </ng-template>
        </button>
        <input #fileInput
               data-cy="doc-upload-input"
               type="file"
               (change)="uploadDocuments($event.target.files)"
               style="display:none;"
               multiple
               [accept]="typesAccepted"/>
      </div>
    </div>
  </div>

  <app-alert *ngIf="ocrolusAlert"
    [level]="ocrolusAlert.level"
    [message]="ocrolusAlert.message"
    (dismissed)="ocrolusAlertDismissed.emit()"
  ></app-alert>

  <app-alert *ngIf="documentAlert"
    [level]="documentAlert.level"
    [message]="documentAlert.message"
    (dismissed)="documentAlertDismissed.emit()"
  ></app-alert>

  <app-alert *ngIf="creditAlert"
    [level]="creditAlert.level"
    [message]="creditAlert.message"
    (dismissed)="creditAlertDismissed.emit()"
  ></app-alert>

  <mat-table #table
             class="tw-pt-2"
    matSort
    matSortActive="createdTimestamp"
    matSortDirection="desc"
    [dataSource]="dataSource"
    [trackBy]="documentTrackBy">

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox class="documents-checkbox-header" (change)="$event ? masterToggle() : null"
          [checked]="selection?.selected?.length === dataSource?.data?.length"
          [indeterminate]="selection?.selected?.length !== dataSource?.data?.length && selection?.selected?.length"
          [aria-label]="checkboxLabel()"
          [matTooltip]="checkboxLabel()"
          matTooltipPosition="above">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let document">
        <mat-checkbox class="documents-checkbox-inner" (click)="$event.stopPropagation();"
          (change)="$event ? [selection.toggle(document), checkOcrolusStatus()] : null"
          [checked]="selection.isSelected(document)"
          [aria-label]="checkboxLabel(document)"
          [disabled]="document.scanStatus !== 'CLEAN' && document.scanStatus !== null">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="title">
      <mat-header-cell class="{{ !compactView ? 'tw-grow-0 tw-basis-[25%]' : '' }}" *matHeaderCellDef mat-sort-header>NAME</mat-header-cell>
      <mat-cell class="{{ !compactView ? 'tw-grow-0 tw-basis-[25%]' : '' }}" *matCellDef="let document; let i = index;">
        <span *ngIf="document.error || document.ocrolusStatus || document.isDupeFilename" class="document-status-icons">
          <i *ngIf="document.ocrolusStatus && !document.error"
            [ngClass]="{
              'VERIFICATION_COMPLETE': 'fa fa-check-circle',
              'VERIFYING': 'fa fa-hourglass',
              'QUEUED': 'fa fa-hourglass',
              'PROCESSING': 'fa fa-hourglass',
              'REJECTED': 'fa fa-times-circle',
              'DELETING': 'fa fa-times-circle',
              'OCROLUS_DELETED': 'fa fa-times-circle',
              'DELETED': 'fa fa-times-circle'
            }[document.ocrolusStatus] || 'fa fa-exclamation-triangle'"
            [matTooltip]="'Ocrolus status: ' + document.ocrolusStatus.replace('_', ' ').toLowerCase()"
            matTooltipPosition="right">
          </i>
          <i *ngIf="document.error"
            [ngClass]="{
              'ocrolus-error-incomplete': document.error === 'Incomplete Information',
              'ocrolus-error-fraud': document.error === 'Potential Fraud'
            }"
            class="fa fa-flag"
            [matTooltip]="document.error + ': ' + document.errorReason"
            matTooltipPosition="right">
          </i>
          <span *ngIf="document.error && document.isDupeFilename || document.ocrolusStatus && document.isDupeFilename"><br /></span>
          <i *ngIf="document.isDupeFilename"
            class="fa fa-warning"
            matTooltip="Dup filename! ({{ document.filename }})"
            matTooltipPosition="right">
          </i>
        </span>

        <div class="tw-w-full">
          <span *ngIf="editDocId !== document.id; else editDocument">
            <!-- title -->
            <div>
              <a *ngIf="(document.scanStatus === 'CLEAN' || document.scanStatus === null)"
                 matTooltip="{{ document.title?.length >= 30 ? document.title : '' }}"
                 [href]="getViewUrl(document.id)" target="_blank" attr.data-cy="doc-title-{{i}}">
                {{ document.title | truncate:30 }}
              </a>
              <span *ngIf="document.scanStatus === 'INFECTED'" matTooltip="Document is infected and has been disabled." attr.data-cy="doc-title-{{i}}">
                {{ document.title | truncate:30 }}
              </span>
              <span *ngIf="document.scanStatus !== 'CLEAN' && document.scanStatus !== 'INFECTED' && document.scanStatus !== null" matTooltip="Please wait until document scanning is complete." attr.data-cy="doc-title-{{i}}">
                {{ document.title | truncate:30 }}
              </span>
            </div>
            <span *ngIf="document.errorReason" class="error-reason">
              {{ document.errorReason }}
              <br />
            </span>
            <span *ngIf="showUploadedBy" class="uploaded-by">
              Uploaded by {{
                document.uploadedBy === 'system' ? 'System Account' :
                document.uploadedBy === 'lenderUser' && document.lenderUser ? document.lenderUser.fullName :
                (document.uploadedBy === 'borrower' && borrower.primary_contact) ? borrower.primary_contact.first + ' ' + borrower.primary_contact.last :
                'unknown'
              }}
            </span>
          </span>
          <ng-template #editDocument>
            <div class="column-grid tw-gap-2">
              <form [formGroup]="editDocForm">
                <mat-form-field class="edit-form" appearance="outline">
                  <input #editInput
                         attr.data-cy="doc-edit-input-{{i}}"
                         class="edit-input"
                         type="text"
                         matInput
                         formControlName="content"
                         (keyup.enter)="editDoc(document)" />
                </mat-form-field>
                <a attr.data-cy="doc-edit-save-{{i}}" (click)="editDoc(document)" class="tw-cursor-pointer">Save</a>
                <a class="cancel-btn tw-cursor-pointer" (click)="editDocId = null">Cancel</a>
              </form>
            </div>
          </ng-template>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="category">
      <mat-header-cell *matHeaderCellDef mat-sort-header> TYPE </mat-header-cell>
      <mat-cell *matCellDef="let document; let i = index;" attr.data-cy="doc-type-dropdown-{{i}}">
          <app-document-category
            [doc]="document"
            [documentCategories]="documentCategories"
            (updateDocCategory)="updateCategory($event)">
          </app-document-category>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="categorySimple">
      <mat-header-cell *matHeaderCellDef> TYPE </mat-header-cell>
      <mat-cell *matCellDef="let document; let i = index;">
        <mat-icon class="verification-icon verification-error" *ngIf="document.ocrolusDocTypeVerified === 0" [matTooltip]="ocrolusDocTypeTooltip(document)">warning</mat-icon>
        <mat-icon class="verification-icon verification-success" *ngIf="document.ocrolusDocTypeVerified === 1" [matTooltip]="ocrolusDocTypeTooltip(document)">check_circle</mat-icon>
        <span>{{getCategoryName(document.category)}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="for">
      <mat-header-cell *matHeaderCellDef> FOR </mat-header-cell>
      <mat-cell *matCellDef="let document; let i = index;">
        <mat-form-field
          attr.data-cy="doc-month-dropdown-{{i}}"
          class="no-subscript"
          *ngIf="document.category === 'bankStatement' || document.category === 'merchantStatement' || document.category === 'mtdTransactions'"
          (click)="$event.stopPropagation()">
          <mat-select [(value)]="document.months"
            placeholder="{{ getMonths(document.months) }}"
            (selectionChange)="updateDocument(document, { type: 'months', value: $event.value })"
            multiple>
            <mat-select-trigger>
              <span *ngFor="let month of document.months; let displayMonthIndex = index;" attr.data-cy="doc-month-display-{{displayMonthIndex}}">
                {{ formatDisplayMonth(month) }} <br />
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let monthOption of monthOptions; let monthIndex = index;" [value]="formatForMonth(monthOption)" attr.data-cy="doc-month-option-{{monthIndex}}">
              {{ monthOption }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdTimestamp">
      <mat-header-cell *matHeaderCellDef class="tw-grow-0 tw-basis-[112px]" mat-sort-header> DATE </mat-header-cell>
      <mat-cell *matCellDef="let document" class="tw-grow-0 tw-basis-[112px]"> {{ document.createdTimestamp * 1000 | date: 'MM/dd/yyyy' }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="scan-status">
      <mat-header-cell *matHeaderCellDef class="tw-grow-0 tw-basis-[100px]"> STATUS </mat-header-cell>
      <mat-cell *matCellDef="let document" class="tw-grow-0 tw-basis-[100px]">
        <div *ngIf="document.scanStatus === 'CLEAN' || document.scanStatus === null">
          Clean
        </div>
        <div *ngIf="document.scanStatus === 'PENDING'">
          Processing
        </div>
        <div *ngIf="document.scanStatus === 'INFECTED'">
          <span class="red">Infected</span>
        </div>
      </mat-cell>
    </ng-container>

<!--    <ng-container matColumnDef="verified">-->
<!--      <mat-header-cell *matHeaderCellDef> VERIFIED </mat-header-cell>-->
<!--      <mat-cell *matCellDef="let document">-->
<!--        <div *ngIf="!canUseDRSDocumentVerify">-->
<!--          {{ !!document.verificationCreated ? 'Yes' : '-' }}-->
<!--        </div>-->
<!--        <mat-checkbox class="documents-checkbox-inner"-->
<!--          *ngIf="canUseDRSDocumentVerify"-->
<!--          (click)="$event.stopPropagation();"-->
<!--          (change)="$event ? toggleVerification(document) : null"-->
<!--          [checked]="!!document.verificationCreated"-->
<!--          [disabled]="(borrower && borrower.profile && borrower.profile[932] && borrower.profile[932].value)"-->
<!--          [aria-label]="checkboxLabel(document)">-->
<!--        </mat-checkbox>-->
<!--      </mat-cell>-->
<!--    </ng-container>-->

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let document; let i = index;">
        <button mat-icon-button class="doc-actions" [matMenuTriggerFor]="menu" attr.data-cy="doc-options-{{i}}">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="after">
          <span attr.data-cy="doc-edit-{{i}}" mat-menu-item (click)="enterEditMode(document)">Edit Name</span>
          <span attr.data-cy="doc-delete-{{i}}" mat-menu-item (click)="confirmDelete([document])">Delete</span>
          <span mat-menu-item *ngIf="document.scanStatus === 'CLEAN' || document.scanStatus === null"(click)="downloadDocument(document.id)">Download</span>
          <button mat-menu-item
                  *ngIf="(canPushToFlashSpread$ | async)"
                  [disabled]="document.isPushedToFlashSpread || document.scanStatus !== 'CLEAN'"
                  [matTooltip]="document.isPushedToFlashSpread ? 'Document already pushed to FlashSpread' : document.scanStatus !== 'CLEAN' ? 'Document scan is not clean' : ''"
                  (click)="pushToFlashSpread(document)">
            Push to FlashSpread
          </button>
        </mat-menu>
      </mat-cell>
    </ng-container>

    <mat-header-row class="documents-table-header" data-cy="docs-table-header" *matHeaderRowDef="tableColumns"></mat-header-row>
    <mat-row @animateIn *matRowDef="let row; let i = index; columns: tableColumns;" attr.data-cy="doc-row-{{i}}"></mat-row>

  </mat-table>

  <mat-paginator #paginator
    [pageSize]="defaultPageSize"
    [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : null"
    [showFirstLastButtons]="true">
  </mat-paginator>
</div>

<ng-template #docUploadLimitDialog>
  <h2 matDialogTitle>Error</h2>
  <p class="tw-w-96">{{'Maximum document upload is ' + documentUploadLimit + ' documents. Please try again selecting at most ' + documentUploadLimit + ' documents.'}}</p>
  <mat-dialog-actions class="tw-float-right">
    <button mat-button [color]="'primary'" matDialogClose>Dismiss</button>
  </mat-dialog-actions>
</ng-template>
